export function getBrowserVersion() {
  const ua = navigator.userAgent.toLowerCase();
  let result = null;
  const IEVersion1 = ua.match(/rv:([\d.]+)\) like gecko/)?.[1];
  const IEVersion2 = ua.match(/msie ([\d.]+)/)?.[1];
  const EdgeVersion = ua.match(/edg\/([\d.]+)/)?.[1];
  const FirefoxVersion = ua.match(/firefox\/([\d.]+)/)?.[1];
  const OperaVersion = ua.match(/(?:opera|opr).([\d.]+)/)?.[1];
  const ChromeVersion = ua.match(/chrome\/([\d.]+)/)?.[1];
  const SafariVersion = ua.match(/version\/([\d.]+).*safari/)?.[1];
  if (IEVersion1 || IEVersion2) {
    result = {
      name: 'IE',
      version: IEVersion2 || IEVersion1,
    };
  } else if (EdgeVersion) {
    result = {
      name: 'EDGE',
      version: EdgeVersion,
    };
  } else if (FirefoxVersion) {
    result = {
      name: 'Firefox',
      version: FirefoxVersion,
    };
  } else if (ChromeVersion) {
    result = {
      name: 'Chrome',
      version: ChromeVersion,
    };
  } else if (OperaVersion) {
    result = {
      name: 'Opera',
      version: OperaVersion,
    };
  } else if (SafariVersion) {
    result = {
      name: 'Safari',
      version: SafariVersion,
    };
  }
  return result;
}

export function compareVersions(version1, version2) {
  // 使用点号分割版本号字符串，并将分割后的字符串转换为数字数组
  const v1 = version1.split('.').map(Number);
  const v2 = version2.split('.').map(Number);

  // 取两个版本数组中较长的那个长度作为比较的轮数
  const len = Math.max(v1.length, v2.length);

  // 逐位比较
  for (let i = 0; i < len; i++) {
    // 如果当前位的数字不同，则返回比较结果
    if (v1[i] > v2[i]) {
      return 1; // 第一个版本号较大
    } else if (v1[i] < v2[i]) {
      return -1; // 第二个版本号较大
    }
  }

  // 如果所有对应的位都相同，则版本号相等
  return 0;
}

export const ComfyBrowserList = [
  {
    name: 'Chrome',
    version: '99.0.0',
  },
];

export const LibBrowserList = [
  {
    name: 'Chrome',
    version: '99.0.0',
  },
  {
    name: 'Firefox',
    version: '98.0.0',
  },
  {
    name: 'Safari',
    version: '16.8.0',
  },
  {
    name: 'Edge',
    version: '99.0.0',
  },
];
